import { Graphics } from 'pixi.js';
import { SVG } from './svg-element';

export class Circle extends SVG<{
  x: number;
  y: number;
  r: number;
}> {
  get type() {
    return 'circle';
  }
  get r() {
    return this.config.r;
  }
  initElement() {
    this._element = new Graphics();
    // this._element.on('pointerover', () => {
    //   console.log('cursor --- yooo');
    //   this._element.cursor = 'crosshair'; // You can set different cursor styles
    // });
  }
  updateAttr() {
    super.updateAttr();
    if (this.element?.destroyed) {
      return;
    }

    // const g = this.element;
    // // -- // -- // -- // -- //
    // g.clear();
    // g.beginFill(0xffffff, 1);
    // g.moveTo(this.x + this.r, this.y); // ensure a valid start point
    // g.arc(this.x, this.y, this.r, 0, Math.PI * 2);
    // g.closePath();
    // g.endFill();

    this.element?.arc(this.x, this.y, this.r, 0, 2 * Math.PI).endFill();
    // this.element.drawCircle(this.x, this.y, this.r).endFill(); //
  }
}
